module.exports = __webpack_public_path__ + "static/media/My_Book.8385834b.gif";